import { InjectionToken } from "@angular/core";

export const PORTAL_LANGUAGE_SHOW_QUERY_PARAM_TOKEN = new InjectionToken<boolean>(
  "PORTAL_LANGUAGE_SHOW_QUERY_PARAM_TOKEN"
);
